/**
 * 全局变量
 * @description 全局变量，非必要不建议使用，请谨慎
 */

import type { App } from "vue";

const code = +(import.meta.env.VITE_SUCCESS_CODE || 200);

export default {
	install(app: App) {
		app.config.globalProperties.$successCode = code;
	},
};
